import React from 'react'
import { Slider, Handles, Tracks, Rail, Ticks } from 'react-compound-slider'
import { Handle, Track, Tick } from './components/SliderComponents'

import {
    LightBackgroundColor,
    IpsaGreen,
} from '../../../../../../../highcharts/HighchartsStyleHelper'

const sliderStyle = {
    // Give the slider some width
    position: 'relative',
    width: '100%',
    height: 80,
    color: 'white',
}

const railStyle = {
    position: 'absolute',
    width: '100%',
    height: 10,
    marginTop: 35,
    borderRadius: 5,
    backgroundColor: IpsaGreen,
    cursor: 'pointer',
}

const railStyleDisabled = {
    position: 'absolute',
    width: '100%',
    height: 10,
    marginTop: 35,
    borderRadius: 5,
    backgroundColor: IpsaGreen,
    cursor: 'pointer',
    opacity: 0.5,
}

const AgeSlider = ({ enabled, sliderChange, domain = [0, 100], step, values = [0, 1] }) => (
    <Slider
        rootStyle={sliderStyle}
        domain={domain}
        step={step}
        values={values}
        onChange={sliderChange}
        mode={1}
    >
        <Rail>
            {(
                { getRailProps } // adding the rail props sets up events on the rail
            ) => <div style={enabled ? railStyle : railStyleDisabled} {...getRailProps()} />}
        </Rail>
        {enabled && (
            <Handles>
                {({ handles, getHandleProps }) => (
                    <div className="slider-handles">
                        {handles.map((handle) => (
                            <Handle
                                key={handle.id}
                                handle={handle}
                                getHandleProps={getHandleProps}
                            />
                        ))}
                    </div>
                )}
            </Handles>
        )}

        {enabled && (
            <Tracks left={false} right={false}>
                {({ tracks, getTrackProps }) => (
                    <div className="slider-tracks">
                        {tracks.map(({ id, source, target }) => (
                            <Track
                                key={id}
                                source={source}
                                target={target}
                                getTrackProps={getTrackProps}
                            />
                        ))}
                    </div>
                )}
            </Tracks>
        )}

        <Ticks count={10}>
            {({ ticks }) => (
                <div className="slider-ticks">
                    {ticks.map((
                        tick // get back ids, values and percents (to place them)
                    ) => (
                        <Tick key={tick.id} tick={tick} count={ticks.length} />
                    ))}
                </div>
            )}
        </Ticks>
    </Slider>
)

export default AgeSlider
